import React, { FC } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'
import TagManager from 'react-gtm-module'

import theme from '../src/theme'

import GDPRSettingsPanel from './components/GDPRSettingsPannel'
import Gdpr from './relay/Gdpr/component'
import GlobalStyles from './theme/global'
import RoutesComponents from './router/RoutesComponents'
import { app } from './configuration'

type AppProps = {
  children?: React.ReactNode
}

const tagManagerArgs = {
  gtmId: app.GTM_ID,
}

TagManager.initialize(tagManagerArgs)

const App: FC<AppProps> = ({ children }) => {
  return (
    <HelmetProvider>
      <Helmet defaultTitle="Cymbae Declare"></Helmet>
      <StyledThemeProvider theme={theme}>
        <GlobalStyles />
        {children}
        <Gdpr />
        <GDPRSettingsPanel />
        <RoutesComponents />
      </StyledThemeProvider>
    </HelmetProvider>
  )
}

export default App
